import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "file-uploader__list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onUpdate:modelValue", "onKeyup"]
const _hoisted_4 = {
  key: 2,
  class: "file-uploader__file-name"
}
const _hoisted_5 = { class: "file-uploader__file-btns" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_progress_bar = _resolveComponent("progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-uploader", { 'drag-over': _ctx.isDragOver }]),
    onDragover: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
    onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
    onDrop: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
  }, [
    _createElementVNode("input", {
      ref: "fileInput",
      type: "file",
      accept: "application/pdf",
      multiple: "",
      hidden: "",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args)))
    }, null, 544),
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
    }, " Select files "),
    _cache[5] || (_cache[5] = _createElementVNode("p", null, "Drag and drop files here to upload.", -1)),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, idx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: idx,
          class: "file-uploader__file"
        }, [
          (file.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(file.error), 1))
            : _createCommentVNode("", true),
          (file.isEditing)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": ($event: any) => ((file.newName) = $event),
                class: "form-control form-control-sm",
                onKeyup: _withKeys(($event: any) => (_ctx.onFileNameChange(file)), ["enter"])
              }, null, 40, _hoisted_3)), [
                [_vModelText, file.newName]
              ])
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(file.name), 1)),
          _createElementVNode("div", _hoisted_5, [
            (file.status === _ctx.FILE_STATUS.UPLOADED && !file.isEditing)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary btn-sm ml-2 align-self-center",
                  onClick: ($event: any) => {
              file.isEditing = true;
              file.newName = file.name;
            }
                }, " Edit ", 8, _hoisted_6))
              : _createCommentVNode("", true),
            (file.isEditing)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-success btn-sm ml-2 align-self-center",
                  onClick: ($event: any) => (_ctx.onFileNameChange(file))
                }, " Confirm ", 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-danger btn-sm ml-2 align-self-center",
              onClick: ($event: any) => (
              file.status === _ctx.FILE_STATUS.PENDING
                ? _ctx.onFileUploadCancel(file)
                : _ctx.onFileRemove(idx)
            )
            }, _toDisplayString(file.status === _ctx.FILE_STATUS.PENDING ? 'Cancel' : 'Remove'), 9, _hoisted_8)
          ]),
          (file.isProgressVisible && !file.error)
            ? (_openBlock(), _createBlock(_component_progress_bar, {
                key: 3,
                class: "file-uploader__file-progress",
                progress: file.progress,
                "progress-text": String(file.progress) + '%'
              }, null, 8, ["progress", "progress-text"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 34))
}